import { render, staticRenderFns } from "./PaymentActionModal.vue?vue&type=template&id=20c24f50&"
import script from "./PaymentActionModal.vue?vue&type=script&lang=js&"
export * from "./PaymentActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports